import { Grid } from "@chakra-ui/react";

/**
 * @typedef {object} Props
 * @property {string} [minCellWidth]
 * @property {React.ReactNode} [children]
 *
 * @param {Props & import("@chakra-ui/react").GridProps} props
 */
function FormGrid({ minCellWidth = "320px", children, ...otherProps }) {
  return (
    <Grid
      gridTemplateColumns={`repeat(auto-fill, minmax(min(${minCellWidth}, 100%), 1fr))`}
      gridGap="1rem"
      {...otherProps}>
      {children}
    </Grid>
  );
}

export default FormGrid;
